module.exports = __webpack_public_path__ + "img/T5-B-xh11.cf55479f.png";